import { render } from "./CsvForm.vue?vue&type=template&id=77abaa07&scoped=true"
import script from "./CsvForm.vue?vue&type=script&lang=js"
export * from "./CsvForm.vue?vue&type=script&lang=js"

import "./CsvForm.vue?vue&type=style&index=0&id=77abaa07&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77abaa07"

export default script